import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, Field, reduxForm} from 'redux-form';
import Select from 'react-select';
import Titulo from '../comum/Titulo';
import buscarTrechos from '../../actions/trecho/buscarTrechos';
import excluirTrechos from '../../actions/trecho/exclurTrecho';
import {
    getAdminEmpresa,
    getGestorEmpresa,
    getOperadorEmpresa,
    getOperadorRemarcacao,
    getVendedorEmpresa,
    getGestorOperacoes,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import Trecho from './Trecho'
import ModalCadastrarTrecho from './ModalCadastrarTrecho';
import {buscarConfiguracoesBilhete} from '../../actions/configuracao-bilhete/configuracaoBilheteActions';
import buscarRegraCalculoBilhete from '../../actions/configuracao-bilhete/buscaRegraCalculoBilheteAction';
import {alterouEmpresa} from '../../actions/empresa/alterarEmpresaSelecionada';
import buscarRotas from '../../actions/rota/buscarRotas';
import selecionarRota from '../../actions/rota/selecionarRota';
import limparTrechos from '../../actions/trecho/limparTrechos';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import {showSuccessMsg} from '../../util/messagesUtil';
import ModalHistoricoTrecho from './ModalHistoricoTrecho';


const ModalConfirmacaoExclusaoTrecho = ({excluir, trecho}) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoTrecho" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content vx-modal-content">
                <div className="vx-modal-header">
                    <div className="vx-modal-header-icon">
                        <i className="material-icons">delete</i>
                    </div>
                    <div>
                        <h5 className="vx-modal-title">Excluir Trecho</h5>
                    </div>
                    <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close">
                        <i className="material-icons">close</i>
                    </button>
                </div>
                <div className="vx-modal-body">
                    <p>Deseja excluir o trecho de <strong>{trecho ? `${trecho.cidadeOrigem} à ${trecho.cidadeDestino.nome}` : ''}</strong>?</p>
                </div>
                <div className="vx-modal-footer">
                    <button id='cancelar' type="button" className="vx-btn-secondary" data-dismiss="modal">Cancelar</button>
                    <button type="button" className="vx-btn-danger" data-dismiss="modal"
                            onClick={() => excluir()}>Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>);

export class PainelGerenciarTrecho extends React.Component {
    constructor(props) {
        super(props);
        this.selecionarTrecho = this.selecionarTrecho.bind(this);
        this.limparCampos = this.limparCampos.bind(this);
        this.excluir = this.excluir.bind(this);
        this.state = {
            trechoSelecionado: null,
            textoFiltro: null,
            ultimoTrecho: '',
            configuracoesBilheteSelecionados: [],
            conexaoUsadas: [],
            cidadesOrigemVendaDireta: [],
            isModalOpen: false
        };
    }

    componentDidMount() {
        this.props.buscarRotas(this.props.empresaSelecionada.id);
        this.props.selecionarRota([]);
        this.props.limparTrechos();
        this.props.buscarRegraCalculoBilhete();
        this.props.buscarConfiguracoesBilhete(this.props.empresaSelecionada.id);
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps)) {
            this.props.buscarRotas(this.props.empresaSelecionada.id);
            this.props.selecionarRota([]);
            this.props.limparTrechos();
            this.props.buscarConfiguracoesBilhete(this.props.empresaSelecionada.id);
        }
        if (this.props.rotaSelecionada && this.props.rotaSelecionada.value && this.props.rotaSelecionada.value !== prevProps.rotaSelecionada.value) {
            this.props.buscarTrechos(this.props.empresaSelecionada.id, this.props.rotaSelecionada.value);
        }
        if (this.props.trechos.length > 0 && this.props.trechos[0].cidadeDestino.nome !== this.state.ultimoTrecho) {
            this.setState({ultimoTrecho: this.props.trechos[0].cidadeDestino.nome})
        }
    }

    limparEmpresaSelecionado() {
        this.setState({trechoSelecionado: null});
    }

    buscarTrechos() {
        this.props.buscarTrechos(this.props.empresaSelecionada.id, this.props.rotaSelecionada.value);
    }

    excluir() {
        this.props.excluirTrechos(this.state.trechoSelecionado.id, this.props.empresaSelecionada.id)
            .then(() => {
                this.buscarTrechos();
                this.limparEmpresaSelecionado();
                showSuccessMsg('Trecho excluído com sucesso');
            })
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroTrecho',
            'idTrecho', '');
        this.props.changeFieldValue('formularioCadastroTrecho',
            'destino', '');
        this.props.changeFieldValue('formularioCadastroTrecho',
            'valor', '');
        this.props.changeFieldValue('formularioCadastroTrecho',
            'tipo', '');
        this.props.changeFieldValue('formularioCadastroTrecho',
            'pontoEmbarque', '');

        this.limparTrechoSelecionado();
        this.props.setIsModalOpen(false);
    }

    setIsModalOpen(isModalOpen) {
        this.setState({isModalOpen})
    }

    selecionarTrecho(trecho) {
        this.setState({trechoSelecionado: trecho});
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotaoNovoTrecho() {
        if (this.props.rotaSelecionada && this.props.rotaSelecionada.value) {
            return (
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                    getAdminEmpresa(this.props.empresaSelecionada.id),
                    getGestorEmpresa(this.props.empresaSelecionada.id),
                    getGestorOperacoes(this.props.empresaSelecionada.id),
                    getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                    <div className="col-12 vx-gp-toolbar">
                        <button data-toggle="modal" data-target="#modalCadastrarTrecho" className="vx-btn-primary">
                            <i className="material-icons">add</i> Novo Trecho
                        </button>
                    </div>
                </Autorizacao>)
        }
        return ''
    }

    exibirTabelaTrechos() {
        if (this.props.trechos && this.props.trechos.length) {
            return (
                <div className="col-12 conteudo-internas">
                    <div className="vx-gp-table-header vx-gp-table-header--trecho d-none d-lg-grid">
                        <div>Ordem</div>
                        <div>Cidade Origem</div>
                        <div>Embarque</div>
                        <div>Cidade Destino</div>
                        <div>Duração</div>
                        <div>KM</div>
                        <div>Taxa Emb.</div>
                        <div>Pedágio</div>
                        <div>Ações</div>
                    </div>
                    {this.exibirTrechos()}
                </div>
            )
        }
        if (this.props.rotaSelecionada && this.props.rotaSelecionada.value) {
            return (
                <div className="col-12 conteudo-internas">
                    <div className="vx-gp-empty">
                        <span className="material-icons vx-gp-empty-icon">compare_arrows</span>
                        <p className="vx-gp-empty-text">Nenhum trecho encontrado para a rota selecionada.</p>
                    </div>
                </div>
            );
        }
    }

    exibirTrechos() {
        return this.props.trechos
            .map((trecho, index) => <Trecho key={index} trecho={trecho}
                                            ultimoTrecho={this.state.ultimoTrecho}
                                            trechos={this.props.trechos}
                                            idEmpresa={this.props.empresaSelecionada.id}
                                            selecionarTrecho={this.selecionarTrecho}
                                            indice={index}                                            
                                            preencherConfiguracoesBilheteSelecinados={this.preencherConfiguracoesBilheteSelecinados.bind(this)}
                                            preencherConexoesUsadas={this.preencherConexoesUsadas.bind(this)}
                                            preencherCidadeOrigemVendaDireta={this.preencherCidadeOrigemVendaDireta.bind(this)}
                                            setIsModalOpen={this.setIsModalOpen.bind(this)} />)
    }

    exibirComboRotas(event) {
        if (this.props.rotas) {
            return (
                <div>
                    <Select
                        {...event.input}
                        noOptionsMessage={() => ('Nenhuma opção encontrada')}
                        placeholder='Selecione uma rota...'
                        options={this.props.rotas.map(elemento => (
                            {
                                label: elemento.descricao,
                                value: elemento.id,
                                opcoesTrechoAlternativo: elemento.opcoesTrechoAlternativo,
                                conexoes: elemento.conexoes
                            }))}
                        onChange={value => this.props.selecionarRota(value)}
                        value={this.props.rotaSelecionada}
                    />
                    {event.meta.touched
                    && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
                </div>
            )
        }
        return '';
    }

    preencherCidadeOrigemVendaDireta(cidadesOrigemVendaDireta) {
        this.setState({ cidadesOrigemVendaDireta })
    }

    limparCidadeOrigemVendaDireta() {
        this.setState({ cidadesOrigemVendaDireta: [] })
    }

    preencherConexoesUsadas(conexaoUsadas) {
        this.setState({ conexaoUsadas })
    }

    limparConexoesUsadas() {
        this.setState({ conexaoUsadas: [] })
    }

    preencherConfiguracoesBilheteSelecinados(configuracoesBilheteSelecionados) {
        this.setState({ configuracoesBilheteSelecionados })
    }

    limparConfiguracoesBilheteSelecionados() {
        this.setState({ configuracoesBilheteSelecionados: [] })
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getOperadorRemarcacao(this.props.empresaSelecionada.id),
                getVendedorEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-md-12">
                    <div className='col-md-12'>
                        <Titulo texto="Gerenciar Trechos" urlRetorno="/"/>
                    </div>
                </div>
                <div className='container-padrao'>
                    <div className='row mb-2'>
                        <div className='col-md-6'>
                            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                                <CampoSelecionarEmpresa/>
                            </Autorizacao>
                        </div>
                    </div>
                    <div className='row'>
                        {this.exibirBotaoNovoTrecho()}
                        <div className="col-12 col-sm-12 col-md-6 mt-2 mb-4">
                            <label>Rota/Prestador</label>
                            <Field name='rota' component={this.exibirComboRotas.bind(this)}/>
                        </div>
                        <div className='col-12 mt-4 mb-0 row d-flex justify-content-center'>
                            <h4> {this.props.rotaSelecionada && this.props.rotaSelecionada.value ? `${this.props.rotaSelecionada.value}: ${this.props.rotaSelecionada.label}` : ''} </h4>
                        </div>
                        {this.exibirTabelaTrechos()}
                    </div>
                </div>
                <ModalCadastrarTrecho 
                    ultimoTrecho={this.state.ultimoTrecho}
                    rotas={this.props.rotas}
                    trechoSelecionado={this.state.trechoSelecionado}
                    trechos={this.props.trechos}
                    conexaoUsadas={this.state.conexaoUsadas}
                    cidadesOrigemVendaDireta={this.state.cidadesOrigemVendaDireta}
                    configuracoesBilheteSelecionados={this.state.configuracoesBilheteSelecionados}
                    preencherConfiguracoesBilheteSelecinados={this.preencherConfiguracoesBilheteSelecinados.bind(this)}
                    limparConfiguracoesBilheteSelecionados={this.limparConfiguracoesBilheteSelecionados.bind(this)}
                    preencherConexoesUsadas={this.preencherConexoesUsadas.bind(this)}
                    limparConexoesUsadas={this.limparConexoesUsadas.bind(this)}
                    preencherCidadeOrigemVendaDireta={this.preencherCidadeOrigemVendaDireta.bind(this)}
                    limparCidadeOrigemVendaDireta={this.limparCidadeOrigemVendaDireta.bind(this)}
                    isModalOpen={this.state.isModalOpen}
                    setIsModalOpen={this.setIsModalOpen.bind(this)}
                />
                <ModalConfirmacaoExclusaoTrecho excluir={this.excluir} trecho={this.state.trechoSelecionado}/>
                <ModalHistoricoTrecho />
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => {    
    return {
        trechos: state.trechos,
        rotas: state.rotas.rotas,
        changeFieldValue,
        empresaSelecionada: state.empresaSelecionada,
        rotaSelecionada: state.rotaSelecionada
    }};


export default connect(mapStateToProps,
    {
        buscarTrechos,
        excluirTrechos,
        buscarRotas,
        buscarRegraCalculoBilhete,
        selecionarRota,
        limparTrechos,
        buscarConfiguracoesBilhete
    })(reduxForm({
    form: 'formularioCadastroTrecho'
})(PainelGerenciarTrecho))
